/**
 * FilterBtn — shared filter toggle button.
 *
 * Style: pill (rounded-full), filled when active, outline when inactive.
 * Matches Bloomberg/FT design system — no high-sat colours.
 */
export function FilterBtn({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={`rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap transition-colors duration-100 ${
        active
          ? "border-primary-700 bg-primary-700 text-white dark:border-primary-500 dark:bg-primary-500"
          : "border-border bg-surface text-ink-secondary hover:border-border-strong hover:text-ink"
      }`}
    >
      {children}
    </button>
  );
}
